import ClassHelper from '../ClassHelper';

class PaymentDetails extends ClassHelper {
  constructor({ paySystem, paySystemId, meta } = {}) {
    super(...arguments);
    this.paySystem = paySystem; // BillTransactionPaymentSystem
    this.paySystemId = paySystemId;
    this.meta = this.obj(meta, Object);
  }
}

export default PaymentDetails;